module.exports = __webpack_public_path__ + "static/awasul_2-87abca000ef4847d4580bd64b867e576.png";